export const HelpDeskMessage = {
  createSuccess: "Help Desk created successfully",
  updateSuccess: "Help Desk updated successfully",
  deleteSuccess: "Help Desk deleted successfully",
  failedCreate: "Failed to create Help Desk",
  failedUpdate: "Failed to update Help Desk",
  failedDelete: "Failed to delete Help Desk",
};
